import PolicyAmendment from './PolicyAmendment'

export default PolicyAmendment
